$(document).ready(function () {
    $(document).foundation();
    showPage();
    Cart.initCartPopup();
    Account.initAccountPopup();
    window.mobileAndTabletCheck = function () {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };
    if (window.mobileAndTabletCheck()) {
        window.history.scrollRestoration = "auto";
    } else {
        window.history.scrollRestoration = "manual";
    }

    $('.catalog-swiper-container').each(function (index, val) {
        if (!$(val).hasClass('swip-initiated')) {
            $(val).addClass('swip-initiated');
            AppSwiper.init('#' + $(val).attr('id'), {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                effect: 'fade',

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination'
                },
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            });
        }
    });

    AppSwiper.init('#homepage-slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        effect: 'fade',

        // If we need pagination
        pagination: {
            el: '.swiper-pagination'
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });
    Checkout.init();
    AppSwiper.init('#taxon-slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        },
        effect: 'fade',
    });

    AppSwiper.init('#homepage-brands-slider', {
        slidesPerView: 10,
        spaceBetween: 10,
        slidesPerGroup: 10,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 8,
                slidesPerGroup: 8
            },
            768: {
                slidesPerView: 6,
                slidesPerGroup: 6
            },
            640: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: true
        }
    });
    AppSwiper.init('#homepage-latest-products-slider', {
        slidesPerView: 5,
        spaceBetween: 30,
        slidesPerGroup: 5,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 40,
                slidesPerGroup: 4,
                slidesPerColumn: 1
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 3,
                slidesPerColumn: 1
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
                slidesPerGroup: 2,
                slidesPerColumn: 1
            }
        }
    });
    AppSwiper.init('.sticker-swiper-slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        effect: 'fade',

        // If we need pagination
        pagination: {
            el: '.swiper-pagination'
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    });
    Product.initProductClickHistory("body.product-index .products-list .product-box-href");
    Product.initInfiniteScroll(".products-list");
    Product.initProductPage(false);
    InfiniteScroll.init('.instapost-list');
    Brand.initReadmore('.brand-description');
    Taxon.initReadmore('.category-description');


    $('.flash-countdown-wrapper').each(function () {
        Countdown.init(this);
    });


    if (getUrlParameter('akr') !== null && getUrlParameter('akr') !== false) {
        window.history.scrollRestoration = "manual";
        if (document.getElementById(getUrlParameter('akr')) != null) {
            document.getElementById(getUrlParameter('akr')).scrollIntoView(true);
        }
    }
    /*$(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $(this.attr(this, 'href')).offset().top - $('body .pusher .top-grid-container').offset().top
        }, 500);
    });*/

    $('.lazy').Lazy({
        // your configuration goes here
        scrollDirection: 'vertical',
        effect: 'fadeIn',
        visibleOnly: true,
        onError: function (element) {
            console.log('error loading ' + element.data('src'));
        }
    });
});

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
}

function showPage() {
    $('body.pushable .pusher').addClass('loaded');
}